module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMA5R2s+sJ4XkYxEvHVCJGmSZLtzrbvthG+AAAAwUlEQVRIx+2R2w6EIAwFW1xUvOHt/P+vromJRVmLxsd1noxkWh3oZcM1jaMb5B/gk9NVjAW6AbCGLlHU4JKoZNQFpakyIKuCJx2ZK7s02m77cvmbVospbaRXGFg/lCGnMYcf61sJHMfUQ8Qx9dSHGSjUy8S6X2ICpAIEge3SIS0sDS2tZJOjtEBuyki4IAjPhJ4RwH1SYOxgVYhPgFe4n/X5xcW8QgDDkIIB0x6PWTHMDH98NUJlNNEQzziFvaF/5guDrxmU9TfYIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_home_dark.png
// module id = 68
// module chunks = 1